import React from 'react'
import { View, StyleSheet } from 'react-native'
import {
  addToJuniorWaitList, addToWaitList,
  getAvailable,
  getJuniorWaitListStatus, getSessionCount, getWaitListStatus,
} from '../../../services/api/LearnDanish'
import { CustomText } from '../../text/StyledText'
import { txt } from '../../../locales/i18n'
import Colors from '../../../constants/Colors'
import { ButtonPrimary, ButtonSecondary } from '../../buttons/StyledButtons'
import NormalIcon from '../../icons/NormalIcon'
import IconNames from '../../../constants/IconNames'
import { ShadowStyles, TypographyStyles } from '../../../styles'
import moment from 'moment'
import { Portal } from 'react-native-paper'
import { ErrorNormalSnackbar } from '../../snackbars/Snackbar'
import TextLabel from './TextLabel'
import SurveyPromptDialog, { platforms } from '../../dialogs/SurveyPromptDialog'
import { surveyIds } from '../../../services/api/Surveys'
import SproglandJuniorWaitListDialog, { SproglandWaitListDialog } from './SproglandWaitListDialog'
import CustomPressable from "../../pressables/CustomPressable"

export default class AvailableSessions extends React.Component {
  constructor(props) {
    super(props)

    //sets locale to danish time
    moment.locale([txt('videoChat.locale')])

    this.state = {
      start_date: Date.now,
      end_date: null,
      showSnackbar: false,
      snackbarText: '',
      isOnWaitlist: false,
      isOnJuniorWaitlist: false,
      surveyPromptVisible: false,
      juniorWaitListVisible: false,
      waitListVisible: false,
      sessionCount: 0,
    }
  }

  async componentDidMount() {
    this.props.loadSessions()
    const waitListStatus = await getWaitListStatus()
    const juniorWaitListStatus = await getJuniorWaitListStatus()
    const sessionCount = await getSessionCount()
    this.setState({
      isOnWaitList: waitListStatus,
      isOnJuniorWaitlist: juniorWaitListStatus,
      sessionCount,
    })
  }

  toggleDropDown = async (key) => {
    // Update dropdownactive
    const tmpData = this.props.sessions
    tmpData[key].dropdownActive = !tmpData[key].dropdownActive

    if (!tmpData[key].dropdownActive) {
      this.setState({ data: tmpData })
      return
    }

    if (tmpData[key].gettingData || tmpData[key].gottenData) {
      if (__DEV__) console.log('Already gotten data for item with key: ' + key)
      this.setState({ data: tmpData })
      return
    }

    tmpData[key].gettingData = true
    this.setState({ data: tmpData })

    // Get data for key
    const startDate = new Date(this.props.sessions[key].date)

    // Add one day (in ms)
    const endDate = new Date(startDate.getTime() + 60 * 60 * 24 * 1000)

    await getAvailable(startDate.getTime(), endDate.getTime(), this.setKeyDates, key, !!this.props.juniorId)
  }

  setKeyDates = async (key, dates) => {
    // Update dropdownactive
    const tmpData = this.props.sessions
    tmpData[key].dates = dates
    tmpData[key].gettingData = false
    tmpData[key].gottenData = true
    tmpData[key].key = key
    this.setState({ data: tmpData })
  }

  formatUnixDate(date) {
    const d = moment(date).format('dddd [d.] DD/MM [kl.] HH:mm')
    return d.charAt(0).toUpperCase() + d.substr(1)
  }

  async handleBookSession(id) {
    const response = await this.props.bookSession(id)

    if (response.firstSession) {
      this.setState({ surveyPromptVisible: true })
    }

    if (response.err_code) {
      const ERR_ENUMS = {
        LIMIT_REACHED: txt('learnDanish.bookingErrors.limitReached'),
        SESSION_NOT_FOUND: txt('learnDanish.bookingErrors.SessionNotFound'),
        SESSION_ALREADY_BOOKED: txt('learnDanish.bookingErrors.alreadyBooked'),
        OWN_BOOKING: txt('learnDanish.bookingErrors.ownBooking'),
        DOUBLE_BOOKING: txt('learnDanish.bookingErrors.doubleBook'),
        DATE_EXPIRED: txt('learnDanish.bookingErrors.dateExpired'),
        TIMEFRAME_OCCUPIED: txt('learnDanish.bookingErrors.timeframeOccupied'),
        VOLUNTEER_IS_ALREADY_IN_TIMEFRAME: txt('learnDanish.bookingErrors.volunteerInTimeframe'),
      }

      const text = ERR_ENUMS[response.err_code] ?? txt('learnDanish.bookingErrors.unknown')
      this.setState({ snackbarText: text, showSnackbar: true })
    } else {
      this.props.reloadBooked()
      this.props.loadSessions()
    }
  }

  onJuniorWaitListPress = async () => {
    const didUpdate = await addToJuniorWaitList()
    if (didUpdate) this.setState({ juniorWaitListVisible: false, isOnJuniorWaitList: true })
  }

  onWaitListPress = async () => {
    const didUpdate = await addToWaitList()
    if (didUpdate) this.setState({ waitListVisible: false, isOnWaitList: true })
  }

  render() {
    return (
      <View style={styles.container}>
        {this.props.sessions.length === 0 ? (
          <View>
            <CustomText font="largeBold" style={styles.titleBold} accessibilityRole="header" aria-level={2}>
              {txt('videoChat.availableSessions')}
            </CustomText>
            <CustomText font="small" style={styles.noSession}>
              {!!this.props.juniorId ?
                txt('learnDanish.noAvailableJuniorSessions') :
                txt('learnDanish.noAvailableSessions')}
            </CustomText>
            {!!this.props.juniorId && !this.state.isOnJuniorWaitList && (
              <ButtonPrimary
                title={txt('learnDanish.junior.waitList.add')}
                accessibilityLabel={txt('learnDanish.junior.waitList.add')}
                onPress={() => this.setState({ juniorWaitListVisible: true })}
                titleStyle={{ ...TypographyStyles.textSmallBold }}
                style={[styles.button, { marginTop: 24 }]}
              />
            )}
            {/*{this.state.sessionCount < 1 && !this.props.juniorId && !this.state.isOnWaitList && (*/}
            {/*  <ButtonPrimary*/}
            {/*    title={txt('learnDanish.waitList.add')}*/}
            {/*    accessibilityLabel={txt('learnDanish.waitList.add')}*/}
            {/*    onPress={() => this.setState({ waitListVisible: true })}*/}
            {/*    titleStyle={{ ...TypographyStyles.textSmallBold }}*/}
            {/*    style={[styles.button, { marginTop: 24 }]}*/}
            {/*  />*/}
            {/*)}*/}
          </View>
        ) : (
          <View>
            <CustomText font="largeBold" style={styles.titleBold} accessibilityRole="header" aria-level={2}>
              {txt('videoChat.availableSessions')}
            </CustomText>
          </View>
        )}
        {this.props.sessions.map((item, key) => {
          if (item.dropdownActive) {
            let itemArray
            if (item.dates.length !== 0) {
              // Render each date
              itemArray = item.dates.map((dateData, index) => {
                // Create smaller marginTop on (index == 0), and borderTop on (index > 0) (for visual purposes)
                let sessionBoxProps
                if (index === 0) sessionBoxProps = { marginTop: 10 }
                else sessionBoxProps = styles.sessionBoxProps
                const date = this.formatUnixDate(dateData.start_date)
                return (
                  <View key={dateData.id} style={[styles.flexRow, { ...sessionBoxProps }]}>
                    <View style={{flex: 1}}>
                      <CustomText font="small">{date}</CustomText>
                      <CustomText
                        font="small"
                        text={
                          txt('videoChat.duration') + ': ' +
                          (new Date(dateData.end_date).getTime() - new Date(dateData.start_date).getTime())
                          / 1000 / 60 + ' min.'
                        }
                      />
                      <CustomText
                        font="small"
                        text={txt('videoChat.volunteer') + ': ' + dateData.username}
                        numberOfLines={1}
                        style={{flex: 1, flexWrap: 'wrap'}}
                      />
                      <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                        {dateData.categories?.map((id) => (
                          <TextLabel
                            key={id}
                            text={txt(`learnDanish.categories.${id}`)}
                            style={{ marginRight: 6, marginTop: 6 }}
                          />
                        ))}
                      </View>
                    </View>

                    <ButtonSecondary
                      title={txt('videoChat.book')}
                      titleStyle={{ ...TypographyStyles.textSmallBold }}
                      style={[styles.button, { borderWidth: 1 }]}
                      onPress={() => this.handleBookSession(dateData.id)}
                    />

                    <Portal>
                      <ErrorNormalSnackbar
                        visible={this.state.showSnackbar}
                        onDismiss={() => this.setState({ showSnackbar: false })}
                        duration={5000}
                      >
                        {this.state.snackbarText}
                      </ErrorNormalSnackbar>
                    </Portal>
                  </View>
                )
              })
            }

            return (
              // Expanded view
              <View style={styles.dropdownContainer}>
                <CustomPressable
                  key={key}
                  onPress={() => this.toggleDropDown(key)}
                  activeOpacity={0.8}
                  accessibilityRole="button"
                  accessibilityLabel={txt('videoChat.availableSessionsHideLabel')}
                >
                  <View style={styles.flexRow}>
                    <CustomText>{item.title}</CustomText>
                    <NormalIcon
                      name={IconNames.arrowUp}
                      color={Colors.inactive}
                      style={styles.icon}
                      size={18}
                      stroke={IconNames.stroke.solid}
                    />
                  </View>
                </CustomPressable>
                {itemArray}
              </View>
            )
          }

          return (
            // Collapsed view
            <CustomPressable
              key={key}
              onPress={() => this.toggleDropDown(key)}
              activeOpacity={0.8}
              style={styles.dropdownContainer}
              accessibilityRole="button"
              accessibilityLabel={txt('videoChat.availableSessionsLabel')}
            >
              <View style={styles.flexRow}>
                <CustomText>{item.title}</CustomText>
                <NormalIcon
                  name={IconNames.arrowDown}
                  color={Colors.inactive}
                  style={styles.icon}
                  size={18}
                  stroke={IconNames.stroke.solid}
                />
              </View>
            </CustomPressable>
          )
        })}
        <SurveyPromptDialog
          visible={this.state.surveyPromptVisible}
          surveyId={surveyIds.sproglandUser}
          platform={platforms.Sprogland}
          surveyLink={'https://survey.rodekors.dk/LinkCollector?key=T57VRJ3MJ636'}
          onDismiss={() => this.setState({ surveyPromptVisible: false })}
        />
        <SproglandJuniorWaitListDialog
          visible={this.state.juniorWaitListVisible}
          onDismiss={() => this.setState({ juniorWaitListVisible: false })}
          submit={this.onJuniorWaitListPress}
        />
        <SproglandWaitListDialog
          visible={this.state.waitListVisible}
          onDismiss={() => this.setState({ waitListVisible: false })}
          submit={this.onWaitListPress}
        />
      </View>
    )
  }
}

const styles = StyleSheet.create({
  button: {
    width: 150,
    paddingHorizontal: 8,
  },
  container: {
    margin: 10,
  },
  dropdownContainer: {
    backgroundColor: Colors.white,
    borderRadius: 2,
    marginTop: 10,
    padding: 10,
    ...ShadowStyles.liftedShadow,
  },
  flexRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  icon: { alignSelf: 'center', marginLeft: 'auto' },
  noSession: {
    color: Colors.inactive,
    marginTop: 10,
    textAlign: 'center',
    backgroundColor: Colors.white,
    padding: 10,
    borderRadius: 2,
    ...ShadowStyles.liftedShadow,
  },
  titleBold: {
    textAlign: 'center',
  },
  waitListBtn: {
    alignSelf: 'center',
    backgroundColor: Colors.tintColor,
    borderRadius: 12,
    marginTop: 24,
    padding: 12,
  },
  sessionBoxProps: {
    borderTopWidth: 1,
    borderColor: Colors.shadow,
    marginTop: 10,
    paddingTop: 10,
  },
})
